import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { siteData } from '../data/mock';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-4 left-0 right-0 z-50 transition-all duration-500 flex justify-center px-4 ${scrolled ? 'py-0' : 'py-2'
        }`}
    >
      <div
        className={`w-full max-w-5xl transition-all duration-500 rounded-full border ${scrolled
            ? 'glass-panel bg-white/70 shadow-lg backdrop-blur-xl border-white/20 py-2 px-6'
            : 'bg-transparent border-transparent py-4 px-4 shadow-none'
          }`}
      >
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#home"
            className="flex items-center gap-2 group"
            onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }}
          >
            <div className="relative w-8 h-8 flex-shrink-0">
              <div className="absolute inset-0 bg-gradient-to-tr from-vibrant-red to-vibrant-purple rounded-full opacity-20 animate-pulse" />
              <div className="absolute inset-1 bg-gradient-to-tr from-vibrant-red to-vibrant-purple rounded-full" />
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-800 font-outfit">
              Wed<span className="text-vibrant-red">Labs</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1 bg-slate-100/50 p-1 rounded-full border border-slate-200/50">
            {siteData.navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-5 py-2 rounded-full text-sm font-medium text-slate-600 transition-all duration-300 hover:bg-white hover:text-vibrant-blue hover:shadow-sm"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <Button
              className="rounded-full px-6 bg-slate-900 text-white hover:bg-vibrant-blue transition-colors duration-300"
              onClick={() => handleNavClick('#templates')}
            >
              Get Started <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>

          {/* Mobile Toggle */}
          <button
            className="lg:hidden p-2 rounded-full hover:bg-slate-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-white/95 backdrop-blur-3xl transition-all duration-500 lg:hidden flex flex-col justify-center items-center ${mobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
          }`}
      >
        <nav className="flex flex-col items-center gap-6">
          {siteData.navLinks.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-2xl font-bold text-slate-800 hover:text-vibrant-blue transition-colors"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              {link.label}
            </a>
          ))}
          <Button
            className="mt-4 rounded-full px-8 py-6 text-lg bg-vibrant-red hover:bg-vibrant-red/90 text-white shadow-xl shadow-vibrant-red/20"
            onClick={() => handleNavClick('#templates')}
          >
            Get Your WedSite
          </Button>
        </nav>
      </div>
    </header>
  );
};
